import { format } from 'date-fns';
import getLocalDate from '../getLocalDate';
import config from '../../config';

const tideTransform = (tides, legacyUserSettings) => {
  let minMax = [0, 0];
  const associated = tides.associated;
  const lastTide = tides.data.tides.length - 1;
  const data = tides.data.tides
    .map((tide, index) => {
      minMax[0] = tide.height < minMax[0] || minMax[0] === 0 ? tide.height : minMax[0];
      minMax[1] = tide.height > minMax[1] ? tide.height : minMax[1];
      const offset = associated.timezone.filter(zone =>
        zone.id === tide.timezone.id)[0].offset;
      const localDate = getLocalDate(tide.timestamp, offset);
      return {
        id: index,
        value: tide.height,
        type: tide.analysis,
        timestamp: localDate,
        monthDay: format(localDate, 'M/D'),
        formattedTime: format(localDate, 'h:mmA'),
        localTimeString: format(localDate, 'MMMM DD, YYYY HH:MM:SS'),
      };
    })
    .filter((tide, index) => !(tide.type === 'NORMAL' && index !== 0 && index !== lastTide));
  const minMaxRegulatorValue = (associated.units.tide === 'm') ? 4 : 6;
  // Smallest height can't be greater than -4
  minMax[0] = (minMax[0] > -minMaxRegulatorValue) ? -minMaxRegulatorValue : minMax[0];
  // Greatest height can't be less than 4
  minMax[1] = (minMax[1] < minMaxRegulatorValue) ? minMaxRegulatorValue : minMax[1];
  const max = minMax[1];
  let tideScale = [];
  switch (true) {
    case (max === 6):
      tideScale = config.pages.forecast.marine_weather.tideScale.six;
      break;
    case (max === 8):
      tideScale = config.pages.forecast.marine_weather.tideScale.eight;
      break;
    case (max > 8 && max <= 12):
      minMax = [-12, 12];
      tideScale = config.pages.forecast.marine_weather.tideScale.twelve;
      break;
    case (max > 12 && max <= 16):
      minMax = [-16, 16];
      tideScale = config.pages.forecast.marine_weather.tideScale.sixteen;
      break;
    case (max > 16 && max <= 20):
      minMax = [-20, 20];
      tideScale = config.pages.forecast.marine_weather.tideScale.twenty;
      break;
    case (max > 20 && max <= 32):
      minMax = [-32, 32];
      tideScale = config.pages.forecast.marine_weather.tideScale.thirtytwo;
      break;
    default:
      tideScale = config.pages.forecast.marine_weather.tideScale.four;
      break;
  }
  return {
    tides: {
      data,
      minMax,
      tideScale,
      units: associated.units.tide !== 'm' ? 'e' : associated.units.tide,
      tz: associated.timezone[0].offset,
      numberOfFreeDays: 2,
      userType: legacyUserSettings.type,
    },
  };
};

export default tideTransform;



// WEBPACK FOOTER //
// ./src/utils/tides/tidesTransform.js